import { configuredFetchBaseQuery } from '@config/rtkQuery';
import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const billingApi = createApi({
  reducerPath: 'billingApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getUserInvoices: builder.query({
      query: (arg) => {
        const url = 'customer/invoices';
        const { page, size, ...params } = arg;
        return { url, params: { page, page_size: size, ...params } };
      },
      providesTags: ['CustomerInvoices'],
    }),
    getInvoiceDetails: builder.query({
      query: ({ uuid }) => ({ url: `customer/invoices/${uuid}` }),
      providesTags: (result, error, { uuid }) => [
        { tag: 'OrderDetails', uuid },
      ],
    }),
    getBalanceHistory: builder.query({
      query: (arg) => {
        const url = 'customer/balance/history';
        const { page, size, ...params } = arg;
        return { url, params: { page, page_size: size, ...params } };
      },
      providesTags: ['CustomerBalanceHistory'],
    }),
    getBalance: builder.query({
      query: () => ({ url: `customer/balance` }),
      transformResponse: (response) => {
        const { balance_threshold: balanceThreshold } = response;
        const balanceThresholdValue = balanceThreshold.slice(0, -1);
        return { balanceThresholdValue, ...response };
      },
      providesTags: (result, error, { login }) => [
        { tag: 'CustomerBalance', id: login },
      ],
    }),
    updateBalanceThreshold: builder.mutation({
      query: ({ data }) => {
        const { balanceThreshold } = data;
        return {
          url: `customer/balance`,
          method: 'PATCH',
          body: { desired_balance_limit: balanceThreshold },
        };
      },
      invalidatesTags: (result, error, { login }) =>
        error ? [] : [{ tag: 'CustomerBalance', id: login }],
    }),
    getBalanceTopUpOptions: builder.query({
      query: () => ({ url: 'customer/balance/top-up/options' }),
      providesTags: (result, error, { login }) => [
        { tag: 'BalanceTopUpOptions', id: login },
      ],
    }),
  }),
});

const initialState = {
  invoices: { isLoading: false, data: [] },
};

const billingSlice = createSlice({
  name: 'billing',
  initialState,
  extraReducers: (builder) => builder,
});

export default billingSlice.reducer;
